import api from "@/lib/api";

// Authenticated PDF/file viewing via Blob (never a raw public URL).
export async function viewProtected(path) {
  const tab = window.open("", "_blank"); // open synchronously to survive popup blockers
  // Environments without a PDF viewer (some webviews/headless) can't render a blob PDF tab.
  const canView = typeof navigator === "undefined" || navigator.pdfViewerEnabled !== false;
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (tab && canView) {
      tab.location.href = url;
    } else {
      if (tab) tab.close();
      const a = document.createElement("a"); // fallback: deliver the file
      a.href = url;
      a.download = "Hoja_DDP.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (tab) tab.close();
    throw e;
  }
}

export async function downloadProtected(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
